import React from 'react'

const AlgoIcon = ({ width = '44px', height = '44px', fill = 'white' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 44 36"
            fill="none"
        >
            <path
                d="M24.4444 5.77756H31.7778V30.222H24.4444V35.1109H44V30.222H36.6667V5.77756H44V0.888672H24.4444V5.77756ZM14.6667 0.888672H4.88889C2.19267 0.888672 0 3.08134 0 5.77756V35.1109H4.88889V22.8887H14.6667V35.1109H19.5556V5.77756C19.5556 3.08134 17.3629 0.888672 14.6667 0.888672ZM4.88889 17.9998V5.77756H14.6667V17.9998H4.88889Z"
                fill={fill}
            />
        </svg>
    );
};

export default AlgoIcon